const appid = 'd8fa29e480f04baaad84c9006f089eb9';
const token = '7952e2dc44cd4cae9e571a58719ee592';

module.exports = {
    appid,
    token
}